import { GetRelativeRoutes } from "@/entities/GetChildRoutes";
import { getChildRoutes } from "@/helpers/routes/getChildRoutes";
import RouteNames from "@/entities/RouteNames";
import Roles from "@/entities/Roles";

// Comment: These components will still be imported but our PaymentRoutesGuard will redirect before they load
const PaymentCardAuthForm = () =>
  import("@/views/payment/PaymentCardAuthForm.vue").then((m) => m.default);
const PricePlansAuthSection = () =>
  import("@/views/payment/PricePlansAuthSection.vue").then((m) => m.default);

// Keep routes structure but users will be redirected away from these pages by PaymentRoutesGuard
const getChoosingPlanRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "choose_plan",
    component: PricePlansAuthSection,
    name: RouteNames.CHOOSE_AUTH_SUBSCRIPTIONS,
    meta: {
      title: "Choose plan",
      roles: [Roles.ADMIN],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
]);

const getAddingPaymentCardAuthFormRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "add_payment_card/:subscriptionPlanId",
    component: PaymentCardAuthForm,
    name: RouteNames.ADD_PAYMENT_CARD_AUTH_FORM,
    props: true,
    meta: {
      title: "Add credit card",
      roles: [Roles.ADMIN],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
]);

export { getAddingPaymentCardAuthFormRoutes, getChoosingPlanRoutes };
